import React, { useState } from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ChatIcon from '@mui/icons-material/Chat';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Navbar from '../components/Navbar';
import WhatsAppBooking from '../components/restaurantDemo/WhatsAppBooking';
import ChatBooking from '../components/restaurantDemo/ChatBooking';
import CalendarBooking from '../components/restaurantDemo/CalendarBooking';
import { Call } from '@mui/icons-material';

const RestaurantDemoScreen = () => {
  const [selectedOption, setSelectedOption] = useState('all'); // 'all', 'whatsapp', 'chat', 'calendar'

  const renderDesktopView = () => (
    <Box
      sx={{
        display: { xs: 'none', md: 'flex' },
        gap: 4,
        justifyContent: 'center',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        mt: 6,
      }}
    >
      <Box sx={{ flex: '0 1 280px', maxWidth: '280px', display: 'flex', flexDirection: 'column', gap: 2 }}>
        <WhatsAppBooking />
        <Button
          variant="contained"
          color="success"
          size="large"
          startIcon={<Call />}
          component="a"
          href="tel:+56227604457"
          sx={{
            py: 2,
            fontSize: '1.1rem',
            textTransform: 'none',
            borderRadius: 2,
          }}
        >
          Llamar por Teléfono
        </Button>
      </Box>
      <Box sx={{ flex: '1 1 350px', maxWidth: '500px' }}>
        <ChatBooking />
      </Box>
      <Box sx={{ flex: '1 1 350px', maxWidth: '600px' }}>
        <CalendarBooking />
      </Box>
    </Box>
  );

  const renderMobileView = () => (
    <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 4, px: selectedOption === 'all' ? 2 : 0 }}>
      {/* Mobile Button Selector */}
      {selectedOption === 'all' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 2 }}>
            <Button
            variant="contained"
            color="success"
            size="large"
            startIcon={<Call />}
            component="a"
            href="tel:+56227604457"
            sx={{
              py: 2,
              fontSize: '1.1rem',
              textTransform: 'none',
              borderRadius: 2,
            }}
          >
            Llamar por Teléfono
          </Button>
          <Button
            variant="contained"
            color="success"
            size="large"
            startIcon={<WhatsAppIcon />}
            onClick={() => setSelectedOption('whatsapp')}
            sx={{
              py: 2,
              fontSize: '1.1rem',
              textTransform: 'none',
              borderRadius: 2,
            }}
          >
            Reservar por WhatsApp
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<ChatIcon />}
            onClick={() => setSelectedOption('chat')}
            sx={{
              py: 2,
              fontSize: '1.1rem',
              textTransform: 'none',
              borderRadius: 2,
            }}
          >
            Reservar por Chat
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            startIcon={<CalendarMonthIcon />}
            onClick={() => setSelectedOption('calendar')}
            sx={{
              py: 2,
              fontSize: '1.1rem',
              textTransform: 'none',
              borderRadius: 2,
            }}
          >
            Reservar por Calendario
          </Button>
        </Box>
      )}

      {/* Selected Component */}
      {selectedOption === 'whatsapp' && (
        <Box>
          <Button
            variant="text"
            onClick={() => setSelectedOption('all')}
            sx={{ mb: 2, ml: 2 }}
          >
            ← Volver
          </Button>
          <WhatsAppBooking />
        </Box>
      )}
      {selectedOption === 'chat' && (
        <Box>
          <Button
            variant="text"
            onClick={() => setSelectedOption('all')}
            sx={{ mb: 2, ml: 2 }}
          >
            ← Volver
          </Button>
          <ChatBooking />
        </Box>
      )}
      {selectedOption === 'calendar' && (
        <Box>
          <Button
            variant="text"
            onClick={() => setSelectedOption('all')}
            sx={{ mb: 2, ml: 2 }}
          >
            ← Volver
          </Button>
          <CalendarBooking />
        </Box>
      )}
    </Box>
  );

  return (
    <div style={{ minHeight: '100vh' }}>
      <Navbar />
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Title */}
        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            fontWeight: 400,
            fontSize: { xs: '2rem', md: '3rem' },
            mb: 1,
          }}
        >
          Reserve como guste
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            textAlign: 'center',
            fontWeight: 200,
            color: 'text.secondary',
            mb: 4,
          }}
        >
          Elija el método que más le convenga para hacer su reserva
        </Typography>

        {/* Desktop View - 3 columns */}
        {renderDesktopView()}

        {/* Mobile View - Button selector */}
        {renderMobileView()}
      </Container>
    </div>
  );
};

export default RestaurantDemoScreen;
